import css from 'styled-jsx/css';

const staticStyles = css`
  .TwoFactorAuth {
    background: #fff;
    padding: 25px;
    box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.06);

    &__title {
      margin-bottom: 25px;
    }

    &__type {
      &-wrapper {
        display: flex;
        margin-bottom: 16px;
        gap: 8px;
        font-size: 16px;
      }

      &-title {
        color: #777;
      }
    }

    &__reset-confirmation {
      &-wrapper {
        max-width: 500px;
        padding: 24px;
        display: flex;
        align-items: center;
        gap: 16px;
        border-radius: 8px;
        background: rgba(242, 178, 51, 0.1);
      }

      &-icon {
        color: #f2b233;
      }

      &-text {
        font-size: 15px;
        font-weight: 500;
      }

      &-buttons {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        margin-top: 24px;
      }
    }
  }

  .ResetTwoFactorAuthSuccess {
    display: flex;
    justify-content: center;
  }
`;

export { staticStyles };
